import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import { registerVisitor } from '../lib/api';

let registrationPromise;
const registerOnce = () => {
  if (!registrationPromise) {
    registrationPromise = registerVisitor().catch((error) => {
      registrationPromise = undefined;
      throw error;
    });
  }
  return registrationPromise;
};

export const VisitorCounter = () => {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let active = true;
    registerOnce().then((data) => { if (active) setTotal(data.total); }).catch(() => { if (active) setTotal(null); });
    return () => { active = false; };
  }, []);

  return (
    <div className="col-span-2 lg:col-span-1 flex items-center justify-center lg:justify-start gap-3 border-t border-white/10 pt-4 lg:border-0 lg:pt-0" data-testid="home-visitor-counter">
      <Eye className="w-5 h-5 text-[#f4b400] shrink-0" aria-hidden="true" />
      <div className="flex items-baseline gap-3 min-w-0">
        <div className="font-display text-3xl md:text-4xl text-[#c8102e] tabular-nums" aria-live="polite" data-testid="home-visitor-count">{total == null ? '—' : new Intl.NumberFormat().format(total)}</div>
        <div className="font-heading text-xs tracking-[0.3em] text-white/70">SITE VISITORS</div>
      </div>
    </div>
  );
};